/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiTextColor } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import type { AnyAdminProject } from '@modules/project-admin-api/types'
import { isProjectDeleted } from '@modules/project-admin-lib/deleted'
import { getDisplayProjectId } from '@modules/project-lib/display'
import genericMessages from '@modules/project-lib/genericMessages'

type Props = {
  project: AnyAdminProject | undefined
}

const AdminProjectPageTitle: React.FunctionComponent<Props> = ({ project }) => {
  const isDeleted = project ? isProjectDeleted(project) : false
  const text = project ? project.name || getDisplayProjectId(project.id) : ''

  if (isDeleted) {
    return (
      <EuiTextColor color='subdued'>
        {text} (<FormattedMessage {...genericMessages.deleted} />)
      </EuiTextColor>
    )
  }

  return <span>{text}</span>
}

export default AdminProjectPageTitle
